var module = angular.module('octopusApp.library', []);


module.config(function($stateProvider, $urlRouterProvider) {

    $stateProvider.state("app.library", {
        url: '/library',
        templateUrl: 'areas/library/views/library_layout.html',
        controller: 'LibraryLayoutController',
        layout: {
            tab: 'library'
        }
    });

    $stateProvider.state("app.library.packages", {
        url: '/packages',
        layout: {
            title: 'Packages',
            libraryTab: "packages"
        },
        templateUrl: 'areas/library/packages/views/index.html',
        controller: 'PackagesIndexController'
    });

    $stateProvider.state("app.library.lifecycles", {
        url: '/lifecycles',
        templateUrl: 'areas/library/lifecycles/views/index.html',
        controller: 'LifecycleIndexController',
        layout: {
            title: 'Lifecycles',
            libraryTab: "lifecycles"
        }
    });

    $stateProvider.state("app.library.lifecycles.new", {
        url: '/new',
        views: {
            "@app.library": {
                templateUrl: 'areas/library/lifecycles/views/create.html',
                controller: 'LifecycleEditController'
            }
        },
        layout: {
            title: 'New Lifecycle'
        }
    });

    $stateProvider.state("app.library.lifecycles.edit", {
        url: '/:id',
        views: {
            "@app.library": {
                templateUrl: 'areas/library/lifecycles/views/edit.html',
                controller: 'LifecycleEditController'
            }
        },
        layout: {
            title: 'Edit Lifecycle'
        }
    });


    $stateProvider.state("app.library.feeds", {
        url: '/feeds',
        layout: {
            title: 'External feeds',
            libraryTab: "feeds"
        },
        templateUrl: 'areas/library/feeds/views/index.html',
        controller: 'FeedsIndexController'
    });


    $stateProvider.state("app.library.feeds.new", {
        url: '/new',
        layout: {
            title: 'New Feed'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/feeds/views/create.html',
                controller: 'FeedEditController'
            }
        }
    });

    $stateProvider.state("app.library.feeds.edit", {
        url: '/:id',
        layout: {
            title: 'Edit Feed'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/feeds/views/edit.html',
                controller: 'FeedEditController'
            }
        }
    });

    $stateProvider.state("app.library.feeds.edit.test", {
        url: '/test',
        layout: {
            title: 'Test Feed'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/feeds/views/test.html',
                controller: 'FeedTestController'
            }
        }
    });


    $stateProvider.state("app.library.packages.upload", {
        url: '/upload',
        layout: {
            title: 'Test Feed'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/packages/views/upload.html',
                controller: 'PackageUploadController'
            }
        }
    });

    $stateProvider.state("app.library.packages.retention", {
        url: '/retention',
        layout: {
            title: 'Retention'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/packages/views/retention.html',
                controller: 'PackageRepositoryRetentionController'
            }
        }
    });


    $stateProvider.state("app.library.packages.versions", {
        url: '/versions/:packageId',
        views: {
            "@app.library": {
                templateUrl: 'areas/library/packages/views/package_versions.html',
                controller: 'PackageVersionsController'
            }
        }
    });

    $stateProvider.state("app.library.packages.details", {
        url: '/:packageId',
        views: {
            "@app.library": {
                templateUrl: 'areas/library/packages/views/package_details.html',
                controller: 'PackageDetailsController'
            }
        }
    });



    $stateProvider.state("app.library.scripts", {
        url: '/scripts',
        layout: {
            title: 'Script Modules',
            libraryTab: "scripts"
        },
        templateUrl: 'areas/library/scripts/views/index.html',
        controller: 'ScriptModulesIndexController'
    });

    $stateProvider.state("app.library.scripts.new", {
        url: '/new',
        layout: {
            title: 'New Script Module'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/scripts/views/create.html',
                controller: 'ScriptModuleEditController'
            }
        }
    });

    $stateProvider.state("app.library.scripts.edit", {
        url: '/:scriptModuleId',
        layout: {
            title: 'Edit Script Module'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/scripts/views/edit.html',
                controller: 'ScriptModuleEditController'
            }
        }
    });

    $stateProvider.state("app.library.steptemplates", {
        url: '/steptemplates',
        layout: {
            title: 'Step Templates',
            libraryTab: "steptemplates"
        },
        templateUrl: 'areas/library/steps/views/index.html',
        controller: 'StepTemplatesIndexController'
    });
    $urlRouterProvider.when('/library/steps', '/library/steptemplates');


    $stateProvider.state("app.library.steptemplates.new", {
        url: '/new/:actionType',
        layout: {
            title: 'New Step Template'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/steps/views/edit.html',
                controller: 'StepTemplateEditController'
            }
        }
    });
    $urlRouterProvider.when('/library/steps/new/:actionType', '/library/steptemplates/new/:actionType');



    // StepTemplates - Community
    $stateProvider.state("app.library.steptemplates.community", {
        url: '/community',
        layout: {
            title: 'Community Step templates'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/steps/views/step_templates.html',
                controller: 'LibraryStepTemplatesController'
            }
        }
    });
    $urlRouterProvider.when('/library/steps/community', '/library/steptemplates/community');



    $stateProvider.state("app.library.steptemplates.community.details", {
        url: '/:id/details',
        layout: {
            title: 'Step template details'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/steps/views/community_step_template_details.html',
                controller: 'StepTemplateDetailsController'
            }
        }
    });
    $urlRouterProvider.when('/library/steps/community/:id/details', '/library/steptemplates/community/:id/details');


    $stateProvider.state("app.library.steptemplates.builtin", {
        url: '/builtin',
        views: {
            "@app.library": {
                templateUrl: 'areas/library/steps/views/step_templates.html',
                controller: 'LibraryStepTemplatesController'
            }
        },
        reloadOnSearch: true
    });
    $urlRouterProvider.when('/library/steps/builtin', '/library/steptemplates/builtin');

    $stateProvider.state("app.library.steptemplates.edit", {
        url: '/:id',
        layout: {
            title: 'Edit Step Template'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/steps/views/edit.html',
                controller: 'StepTemplateEditController'
            }
        }
    });
    $urlRouterProvider.when('/library/steps/:id', '/library/steptemplates/:id');


    $stateProvider.state("app.library.steptemplates.edit.logo", {
        url: '/logo',
        layout: {
            title: 'Step Template Logo'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/steps/views/change_logo.html',
                controller: 'ActionTemplateLogoController'
            }
        }
    });
    $urlRouterProvider.when('/library/steps/:id', '/library/steptemplates/:id');


    $stateProvider.state("app.library.steptemplates.edit.run", {
        url: '/run',
        layout: {
            title: 'Run Step Template'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/steps/views/run.html',
                controller: 'StepTemplateRunController'
            }
        },
        reloadOnSearch: false
    });
    $urlRouterProvider.when('/library/steps/:id/run', '/library/steptemplates/:id/run');

    $stateProvider.state("app.library.tagsets", {
        url: '/tagsets',
        layout: {
            title: 'Tag Sets',
            libraryTab: "tagsets"
        },
        templateUrl: 'areas/library/tagsets/views/index.html',
        controller: 'TagSetsIndexController'
    });

    $stateProvider.state("app.library.tagsets.new", {
        url: '/new',
        layout: {
            title: 'New Tenant Tag Set'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/tagsets/views/create_tag_set.html',
                controller: 'TagSetEditController'
            }
        }
    });

    $stateProvider.state("app.library.tagsets.edit", {
        url: '/:id',
        layout: {
            title: 'Edit Tenant Tag Set'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/tagsets/views/edit_tag_set.html',
                controller: 'TagSetEditController'
            }
        }
    });

    $stateProvider.state("app.library.variables", {
        url: '/variables',
        layout: {
            title: 'Variables Sets',
            libraryTab: "variables"
        },
        templateUrl: 'areas/library/variables/views/index.html',
        controller: 'VariableSetsIndexController'
    });

    $stateProvider.state("app.library.variables.new", {
        url: '/new',
        layout: {
            title: 'New Variable Set'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/variables/views/create_variable_set.html',
                controller: 'VariableSetEditController'
            }
        }
    });

    $stateProvider.state("app.library.variables.edit", {
        url: '/:id',
        layout: {
            title: 'Edit Variable Set'
        },
        views: {
            "@app.library": {
                templateUrl: 'areas/library/variables/views/edit_variable_set.html',
                controller: 'VariableSetEditController'
            }
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/library_module.js
// module id = 853130575338270
// module chunks = 1